import { Api } from '../../api';
import { IStatParams, IStatBasicParams } from '../../interfaces';
import { AppStat } from './AppStat';

export class StatInstanceBase {

	protected parent: AppStat;

	constructor(parent: AppStat) {
		this.parent = parent;
	}

	async sendStat(params: IStatParams) {
		if (!IS_SSR) {
			return Api.stat.baseStat.sendStat({
				...params,
				...this.getBasicParams(),
			});
		} else {
			return Promise.resolve();
		}
	}

	getBasicParams(): IStatBasicParams {
		const currentUser = this.parent.currentUser;
		const url = this.parent.routeData && this.parent.routeData.url || window.location.pathname || '';

		return {
			userId: currentUser != null ? currentUser.oauthId : '',
			url,
		};
	}

}
